const router = {
  namespaced: true,
  state: {
    name: 'default',
    vesionRouter: {
      2022: 'default',
      2021: 'v32'
    }
  },
  getters: {
    GetName (state) {
      return state.name
    }
  },
  mutations: {
    SET_ROUTER_NAME: (state, date = new Date().getFullYear()) => {
      state.name = state.vesionRouter[date + ''] || 'default'
    }
  },
  actions: {

  }
}

export default router
